import { render, staticRenderFns } from "./BrandModelView.vue?vue&type=template&id=3851cf6b&"
import script from "./BrandModelView.vue?vue&type=script&lang=js&"
export * from "./BrandModelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports